import { Settings } from "lucide-react";
import { ESTADO_LABELS, ESTADO_COLORS, RESULTADO_OPTIONS } from "../../lib/leadEstado";

const inputClass =
  "w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-brand/20 focus:border-brand outline-none";
const selectClass = `${inputClass} bg-white`;

export function FormField({ label, children, required }) {
  return (
    <div>
      <label className="block text-xs font-medium text-gray-600 mb-1">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      {children}
    </div>
  );
}

function SelectWithConfig({ label, value, onChange, options, onConfigure }) {
  return (
    <FormField label={label}>
      <div className="flex gap-1.5">
        <select value={value || ""} onChange={onChange} className={`${selectClass} flex-1`}>
          <option value="">Seleccionar...</option>
          {options.map((o) => (
            <option key={o.id} value={o.name}>{o.name}</option>
          ))}
        </select>
        <button
          type="button"
          onClick={onConfigure}
          className="px-2.5 py-2 text-gray-400 hover:text-brand hover:bg-brand-light border border-gray-200 rounded-lg transition-colors"
          title={`Configurar opciones de ${label}`}
        >
          <Settings size={16} />
        </button>
      </div>
    </FormField>
  );
}

export default function LeadFormFields({
  form,
  isEditing,
  estadoCalculado,
  update,
  conocioOptions,
  canalOptions,
  servicioOptions,
  onConfigureOptions,
}) {
  const estadoLabel = ESTADO_LABELS[estadoCalculado] || ESTADO_LABELS.pendiente;
  const estadoColor = ESTADO_COLORS[estadoCalculado] || ESTADO_COLORS.pendiente;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <FormField label="Nombre" required>
        <input
          type="text"
          value={form.nombre}
          onChange={(e) => update("nombre", e.target.value)}
          className={inputClass}
          placeholder="Nombre del lead"
          autoFocus
        />
      </FormField>

      {isEditing && (
        <FormField label="Estado (calculado)">
          <div className={`px-3 py-2 text-sm rounded-lg font-medium ${estadoColor}`}>
            {estadoLabel}
          </div>
        </FormField>
      )}

      <FormField label="Fecha Contacto" required>
        <input
          type="date"
          value={form.fecha_contacto}
          onChange={(e) => update("fecha_contacto", e.target.value)}
          className={inputClass}
        />
      </FormField>

      {isEditing && (
        <>
          <FormField label="Resultado">
            <select
              value={form.resultado || ""}
              onChange={(e) => update("resultado", e.target.value)}
              className={selectClass}
            >
              <option value="">Sin resultado</option>
              {RESULTADO_OPTIONS.map((o) => (
                <option key={o.value} value={o.value}>{o.label}</option>
              ))}
            </select>
          </FormField>

          <FormField label="Fecha Resultado">
            <input
              type="date"
              value={form.fecha_resultado}
              onChange={(e) => update("fecha_resultado", e.target.value)}
              className={inputClass}
            />
          </FormField>
        </>
      )}

      <SelectWithConfig
        label="Canal"
        value={form.canal}
        onChange={(e) => update("canal", e.target.value)}
        options={canalOptions}
        onConfigure={() => onConfigureOptions("canal")}
      />

      <SelectWithConfig
        label="Servicio"
        value={form.servicio}
        onChange={(e) => update("servicio", e.target.value)}
        options={servicioOptions}
        onConfigure={() => onConfigureOptions("servicio")}
      />

      <FormField label="Sesión Prueba">
        <label className="flex items-center gap-2 py-2">
          <input
            type="checkbox"
            checked={form.sesion_prueba}
            onChange={(e) => update("sesion_prueba", e.target.checked)}
            className="w-4 h-4 rounded border-gray-300 text-brand focus:ring-brand"
          />
          <span className="text-sm text-gray-700">Realizó sesión de prueba</span>
        </label>
      </FormField>

      <FormField label="Teléfono">
        <input
          type="tel"
          value={form.telefono}
          onChange={(e) => update("telefono", e.target.value)}
          className={inputClass}
          placeholder="666 777 888"
        />
      </FormField>

      <FormField label="Email">
        <input
          type="email"
          value={form.email}
          onChange={(e) => update("email", e.target.value)}
          className={inputClass}
          placeholder="email@ejemplo.com"
        />
      </FormField>

      <SelectWithConfig
        label="Cómo nos conoció"
        value={form.como_conocio}
        onChange={(e) => update("como_conocio", e.target.value)}
        options={conocioOptions}
        onConfigure={() => onConfigureOptions("conocio")}
      />

      <div className="sm:col-span-2">
        <FormField label="Observaciones">
          <textarea
            value={form.observaciones}
            onChange={(e) => update("observaciones", e.target.value)}
            rows={2}
            className={inputClass}
            placeholder="Notas generales..."
          />
        </FormField>
      </div>
    </div>
  );
}
